import { useState, useRef, useCallback } from "react";

export function useDrag(
  initial: { x: number; y: number },
  elementRef: React.RefObject<HTMLDivElement>
) {
  const [pos, setPos] = useState(initial);
  const posRef = useRef(pos);
  posRef.current = pos;

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      if (e.button !== 0) return;
      e.preventDefault();
      const startX = e.clientX, startY = e.clientY;
      const startPosX = posRef.current.x, startPosY = posRef.current.y;
      document.body.style.cursor = "grabbing";

      const onMove = (ev: MouseEvent) => {
        const x = Math.max(0, Math.min(startPosX + ev.clientX - startX, window.innerWidth - 200));
        const y = Math.max(0, startPosY + ev.clientY - startY);
        // Mutate DOM directly — setState here would re-render on every pixel
        // and cause severe lag with Plotly charts mounted inside the window.
        if (elementRef.current) {
          elementRef.current.style.left = `${x}px`;
          elementRef.current.style.top = `${y}px`;
        }
        posRef.current = { x, y };
      };

      const onUp = () => {
        document.body.style.cursor = "";
        setPos({ ...posRef.current });
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
      };

      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
    },
    [elementRef]
  );

  return { pos, onMouseDown };
}
